<app-header></app-header>

<!--============ Breadcumb ============= -->
<div class="breadcumb-wrapper" data-bg-src="assets/img/bg/breadcumb-bg.jpg">
    <div class="container">
        <div class="breadcumb-content">
            <h1 class="breadcumb-title">Testing and Quality Assurance</h1>
            <ul class="breadcumb-menu">
                <li><a routerLink="/">Home</a></li>
                <li>Testing & Review</li>
            </ul>
        </div>
    </div>
</div>

<section class="space">
    <div class="container">
        <div class="row">
            <div class="col-xxl-8 col-lg-7">
                <div class="page-single">
                    <div class="service-img sv-details-img">
                        <img class="w-100" src="assets/img/service/4-1.jpg.webp" alt="Testing & review" />
                    </div>
                    <div class="page-content sv-content d-block">
                        <h2 class="box-title">Testing and Quality Assurance</h2>
                        <p class="box-text mb-30">The testing process in web application development involves evaluating
                            the functionality, performance, and quality of the application to ensure that it meets the
                            specified requirements and provides a satisfactory user experience. Testing helps identify
                            and fix bugs, verify the application’s behavior, and validate its performance under
                            different conditions.
                        </p>
                        <div class="sv-gallery-wrapper">
                            <h2 class="box-title">Why Testing & Review Important?</h2>
                            <div class="row gy-4">
                                <div class="col-6">
                                    <div class="sv-sm-img">
                                        <img class="w-100" src="assets/img/service/video-image-1.jpg.webp" alt="" />
                                    </div>
                                </div>
                                <div class="col-6 my-5">
                                    <p>Here are the key steps involved in the testing process:</p>
                                    <div class="checklist tick-checklist sv-details-list mb-40">
                                        <ul class="list">
                                            <li>Test Planning and Case Development</li>
                                            <li>Unit Testing and Integration Testing</li>
                                            <li>System and Functional Testing</li>
                                            <li>Usability Performance Testing</li>
                                            <li>Security Regression Testing</li>
                                            <li>User Acceptance Testing (UAT)</li>
                                            <li>Bug Tracking and Reporting</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row gy-4">
                                <div class="col-12">
                                    <p>By following a thorough testing process, web application development teams can
                                        ensure the application’s quality, functionality, and performance before it is
                                        deployed to production. Testing helps identify and address issues early in the
                                        development</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xxl-4 col-lg-5">
                <app-service-sidebar></app-service-sidebar>
            </div>
        </div>
    </div>
</section>

<!--======== Footer Section ========-->
<app-footer></app-footer>